import { eAtlas, eMaterialAsset, Game, rnd2 } from "../../Game";
import { ModelUtils } from "../../Utils/Models/ModelUtils";
import { PlaneMesh } from "../../Utils/Models/PlaneMesh";
import { AtlasUtils } from "../../Utils/Atlas/AtlasUtils";



export class Guards {
    /**
     * Pozice strazcu na X
     */
    private static readonly POS_X: number[] = [-13, -9, -5, 5, 9, 13];

    /**
     * Pocet grafickych verzi
     */
    private static readonly VERSION_CNT = 4;
    private static readonly PIXELS_PER_UNIT = 120;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        let meshCreator = Game.planeMeshCreator;
        let atlas = Game.getAtlas(eAtlas.def1);
        let guardPos = new pc.Vec3();
        let guardVerOffsets = new pc.Vec4();
        let guardUVs = new pc.Vec4();

        meshCreator.reset();

        Guards.POS_X.forEach((guardPosX: number): void => {
            let frame = atlas.frames["guards/" + rnd2.randomIntIn(0, Guards.VERSION_CNT - 1)] as pc.TextureAtlasFrame;
            let frameRect = frame.rect;
            let frameW = frameRect.z / Guards.PIXELS_PER_UNIT;
            let frameH = frameRect.w / Guards.PIXELS_PER_UNIT;
            let framePivot = frame.pivot;

            // Ulozit pozici strazce
            guardPos.set(guardPosX, 0, 0);

            // Ulozit offsety vrcholu
            guardVerOffsets.set(-frameW * framePivot.x, -frameH * framePivot.y, frameW * (1 - framePivot.x), frameH * (1 - framePivot.y));

            // Ulozit UVs pro jednotlive vrcholy
            AtlasUtils.getTexFrameRegion(atlas.texture, frameRect, guardUVs);

            // Zapsat do dat meshe
            meshCreator.addPlane(guardPos, guardVerOffsets, guardUVs);
        });

        let mesh = new pc.Mesh(Game.app.graphicsDevice);

        meshCreator.calculateNormals();
        meshCreator.initMesh(mesh);

        let model = ModelUtils.createModel([mesh],
            Game.app.assets.find(eMaterialAsset.atlasWithOpacity, pc.eAssetType.material).resource as pc.StandardMaterial);

        // Vytvorit entitu
        let entity = new pc.Entity();

        entity.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.asset,
            castShadows: false,
            receiveShadows: false,
            isStatic: true,
        });
        entity.model.model = model;
        entity.setLocalPosition(0, 2, -50.1);

        Game.app.root.addChild(entity);
    }
}